(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ApplicationService', ApplicationService)

    /** @ngInject */
    function ApplicationService(HttpService, APPLICATION_URLS) {
        const ApplicationService = {
            getByParameters: getByParameters,
            get: get,
            getAll: getAll,
            getAllByAccessLevel: getAllByAccessLevel,
            getApiControllers: getApiControllers,
            getApiEndpoints: getApiEndpoints,
            generateRandomHash: generateRandomHash,
            post: post,
            put: put,
            delete: deleteApplication,
            validateCallbackUrl: validateCallbackUrl
        }

        return ApplicationService;

        function getByParameters(params) {
            return HttpService.get('/applications', {
                params
            });
        }

        function get(applicationId) {
            return HttpService.get(`/applications/${applicationId}`);
        }

        function getAll() {
            return HttpService
                .get('/applications/all')
                .then(normalizeApplicationUrls);
        }

        function getAllByAccessLevel(accessLevelId) {
            return HttpService
                .get(`/applications/access-level/${accessLevelId}`)
                .then(normalizeApplicationUrls);
        }

        function getApiControllers() {
            return HttpService.get('/api-controllers');
        }

        function getApiEndpoints() {
            return HttpService.get('/api-controllers/endpoints');
        }

        function generateRandomHash() {
            return HttpService.get(`/applications/generate-new-token/32`);
        }

        function post(application) {
            return HttpService.post('/applications', application);
        }

        function put(application) {
            return HttpService.put('/applications', application);
        }

        function deleteApplication(applicationId) {
            return HttpService.delete(`/applications/${applicationId}`);
        }

        function validateCallbackUrl(params) {
            return HttpService.get('/applications/is-valid-callback-url', {
                params
            });
        }

        function normalizeApplicationUrls(applications) {
            if (!Array.isArray(applications))
                return applications;

            return applications.map(application => {
                if (application.ApplicationUrl)
                    application.ApplicationUrl = normalizeApplicationUrl(application.ApplicationUrl);

                return application;
            });
        }

        function normalizeApplicationUrl(applicationUrl) {
            if (!APPLICATION_URLS.CENTRAL_PURCHASES)
                return applicationUrl;

            return applicationUrl.replace(/^https?:\/\/central\.lavpop\.com\.br/i, APPLICATION_URLS.CENTRAL_PURCHASES);
        }
    }
}());
